(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const itemBox = document.querySelector('[data-cart-items]');
  const totalBox = document.querySelector('[data-cart-total]');
  const countBoxes = document.querySelectorAll('[data-cart-count]');

  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
  }).format(cents / 100);

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    window.setTimeout(() => { overlay.hidden = true; }, 250);
    document.body.style.overflow = '';
  }

  async function refreshCart(open = false) {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart could not be loaded.');
    const cart = await response.json();
    countBoxes.forEach(el => { el.textContent = cart.item_count; });
    if (totalBox) totalBox.textContent = money(cart.total_price);
    if (itemBox) {
      itemBox.innerHTML = cart.items.length ? cart.items.map(item => `
        <div class="drawer-line">
          ${item.image ? `<img src="${item.image}" alt="">` : '<span></span>'}
          <div><h3>${item.product_title}</h3><p>Qty ${item.quantity}</p></div>
          <p>${money(item.final_line_price)}</p>
        </div>`).join('') : '<p>Your cart is empty.</p>';
    }
    if (open) openDrawer();
  }

  document.querySelectorAll('[data-cart-open]').forEach(button => button.addEventListener('click', () => refreshCart(true)));
  document.querySelectorAll('[data-cart-close]').forEach(button => button.addEventListener('click', closeDrawer));
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeDrawer(); });

  document.querySelectorAll('form[data-ajax-cart]').forEach(form => {
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (button) { button.disabled = true; button.dataset.label = button.textContent; button.textContent = 'Adding...'; }
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('This item could not be added.');
        await refreshCart(true);
      } catch (error) {
        window.alert(error.message);
      } finally {
        if (button) { button.disabled = false; button.textContent = button.dataset.label; }
      }
    });
  });
})();
